import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const submissionApi = createApi({
  reducerPath: "submission",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/submission" }),
  tagTypes: ["Submission"],
  endpoints: (builder) => ({
    createSubmission: builder.mutation({
      query: (formData) => ({
        url: "/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Submission"],
    }),

    gradeSubmission: builder.mutation({
      query: ({ submissionId, formData }) => ({
        url: `/${submissionId}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Submission"],
    }),

    editGradeSubmission: builder.mutation({
      query: ({ submissionId, formData }) => ({
        url: `/${submissionId}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Submission"],
    }),

    getSubmissions: builder.query({
      query: ({ batchCode, assignmentId, studentId }) => {
        const params = new URLSearchParams();
        if (batchCode) params.append("batchCode", batchCode);
        if (assignmentId) params.append("assignmentId", assignmentId);
        if (studentId) params.append("studentId", studentId);
        return {
          url: `/?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Submission"],
    }),

    // Interview submission
    createInterviewSubmission: builder.mutation({
      // Complete an interview for a specific interviewId
      // payload: { interviewId, Token, formData }
      query: ({ interviewId, Token, formData }) => ({
        url: `/interview/${interviewId}`,
        method: "POST",
        headers: {
          Authorization: Token ? `Bearer ${Token}` : undefined,
          "Content-Type": "application/json",
        },
        body: formData,
      }),
      invalidatesTags: ["Interview", "Students", "Student"],
    }),
  }),
});

export const {
  useGetSubmissionsQuery,
  useCreateSubmissionMutation,
  useCreateInterviewSubmissionMutation,
  useGradeSubmissionMutation,
  useEditGradeSubmissionMutation,
} = submissionApi;
